<template>
  <Transition name="loader-fade">
    <div v-if="isVisible" class="page-loader">
      <img
        src="@/assets/images/logo-card.webp"
        alt="Semillero del Oeste"
        class="loader-logo"
        fetchpriority="high"
        decoding="async"
        width="120"
        height="170"
      />
    </div>
  </Transition>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const isVisible = ref(true);
const MIN_DISPLAY_MS = 450;

onMounted(() => {
  const start = Date.now();

  const hide = () => {
    const elapsed = Date.now() - start;
    const remaining = Math.max(0, MIN_DISPLAY_MS - elapsed);
    setTimeout(() => {
      isVisible.value = false;
    }, remaining);
  };

  if (document.readyState === 'complete') {
    hide();
  } else {
    window.addEventListener('load', hide, { once: true });
  }
});
</script>

<style scoped>
.page-loader {
  position: fixed;
  inset: 0;
  z-index: 99999;
  background-color: #070707;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.loader-logo {
  width: 120px;
  height: auto;
  max-height: 170px;
  object-fit: contain;
  animation: logoPulse 1.2s ease-in-out infinite;
}

@keyframes logoPulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.55;
  }
}

/* Fade-out al salir */
.loader-fade-leave-active {
  transition: opacity 0.45s ease;
}
.loader-fade-leave-to {
  opacity: 0;
}
</style>
